export class Token{
    token:string;
    expiration:string;
}